import axios from 'axios';
import useAuthStore from '../stores/auth.store';

export const apiV1 = axios.create({
  baseURL: process.env.REACT_APP_CHAT_API_URL,
});

apiV1.interceptors.request.use(
  function (config) {
    const token = useAuthStore.getState().authToken;
    config.headers['Authorization'] = `Bearer ${token}`;
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  },
);

// Add a response interceptor
apiV1.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    return Promise.reject(error);
  },
);
